import { render, staticRenderFns } from "./ProductKeywordsList.vue?vue&type=template&id=157e69e2&"
import script from "./ProductKeywordsList.vue?vue&type=script&lang=js&"
export * from "./ProductKeywordsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports